import type { Network, TrainPrediction } from '@tol/core/gps-types';
import type { GtfsTrip } from './unrouted-types.ts';

export function unroutedGps(trip: GtfsTrip, net: Network, now: number): TrainPrediction | null {
  const { lat, lon, gt } = trip;
  if (
    trip.unrouted !== true ||
    lat === undefined ||
    lon === undefined ||
    gt === undefined ||
    !Number.isFinite(lat) ||
    !Number.isFinite(lon) ||
    !Number.isFinite(gt) ||
    Math.abs(lat) > 90 ||
    Math.abs(lon) > 180 ||
    gt <= 0 ||
    gt * 1000 > now + 30_000 ||
    now - gt * 1000 >= 180_000
  )
    return null;
  return {
    key: trip.id,
    lineId: trip.line,
    P: null,
    N: trip.calls[0]?.[0] ?? trip.dest,
    eta: gt * 1000,
    segT: 0,
    dest: net.stations.get(trip.dest)?.name ?? '',
    towards: '',
    loc: 'GPS position',
    platform: '',
    vid: trip.vid,
    waiting: false,
    stops: [],
    gps: true,
    gpsPoint: { lat, lon, at: gt * 1000 },
  };
}
